import { createContext, use } from 'react'

import { CommandMenuContextType } from '~/components/command-menu/types'

export const useCommandMenu = () => {
  const commandMenu = use(CommandMenuContext)

  if (!commandMenu) {
    throw new Error('useCommandMenu must be used within CommandMenuProvider')
  }

  return commandMenu
}

export const CommandMenuContext = createContext<CommandMenuContextType | null>(
  null,
)
